import React, { useEffect } from 'react';
import './OpenPage.scss';
import { isAfter, isBefore } from 'common-modules/general/Modules/functions';
import moment from 'moment';
import InnerHTML from 'dangerously-set-html-content';
import FooterEventModel from 'common-modules/general/Common/Logic/Event/EventCommon';
import { observer, useLocalObservable } from 'mobx-react';
import { toJS } from 'mobx';
import { useLocation } from 'react-router-dom';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { Redirect, useHistory } from 'react-router';

const OpenPage = observer(() => {
  const params = useLocation();
  const id = params.search.replace('?id=', '');
  const history = useHistory();

  const renderProcess = (startDate, endDate) => {
    if (isAfter(startDate)) {
      return '예정';
    } else if (isBefore(endDate)) {
      return '진행중';
    } else {
      return '종료';
    }
  };

  const { model: eventModel } = useLocalObservable(() => ({ model: new FooterEventModel() }));

  useEffect(() => {
    eventModel.getEventDetailData(id);
  }, [id]);

  const detailData = toJS(eventModel.eventDetail.data);

  if (eventModel.eventDetail.loadStatus === 'READY' && detailData) {
    return (
      <>
        <div className="view-item">
          <div className="view-list">
            <div className="tit-area">
              <p className={`tag-tit ${isBefore(detailData.dtEnd) ? 'ing' : 'end'}`}>
                {renderProcess(detailData.dtBegn, detailData.dtEnd)}
              </p>
              <span className="txt-desc-medium01">{detailData.dsEvnt}</span>
              <p className="tit">{detailData.sbjtNtcPlte}</p>
              <span className="date">
                {moment(detailData.dtBegn).format('YYYY.MM.DD')} ~ {moment(detailData.dtEnd).format('YYYY.MM.DD')}
              </span>
            </div>
            <div className="info-area">
              <div className="img-area">
                <InnerHTML html={detailData.clDesc != null ? (detailData.clDesc as string) : ''} />
              </div>
            </div>
          </div>
        </div>

        <div className="event-detail container mb-75">
          <button className="btn-round02" type="button" onClick={() => history.push(RoutesString.SalesEvent)}>
            <span className="txt">목록</span>
          </button>
        </div>
      </>
    );
  } else if (eventModel.eventDetail.loadStatus === 'PENDING') {
    return <div style={{ height: '1000px' }}></div>;
  } else {
    return <Redirect to={RoutesString.SalesEvent} />;
  }
});

export default OpenPage;
